<template>
  <article class="pl-chat-user-list__area">
    <h4 class="pl-chat-user-list__users-list-subtitle">Участники чата</h4>
    <v-text-field class="pl-chat-user-list__filter" v-model="filterValue" label="Фильтр по участникам чата" />

    <div v-if="!items.length" class="pl-chat__messages pl-chat__messages--chat-list-empty">
      В чате пока нет участников
    </div>

    <ul class="pl-chat-user-list">
      <li
        class="pl-chat-user-list__item"
        v-for="member in items"
        :key="member.id"
        :class="{ 'pl-chat-user-list__item--not-change': itSelf(member.id) }"
      >
        <pl-chat-avatar :entity="member" />

        <div class="pl-chat-user-list__item-body">
          <div class="pl-chat-user-list__title">
            <div class="pl-chat-user-list__name">
              {{ getNumberPhoneMember(member) }}
            </div>
          </div>

          <div class="pl-chat-user-list__button-action">
            <v-btn v-if="!itSelf(member.id)" icon @click="$emit('remove-member', member)">
              <v-icon color="rgba(0,0,0,0.6)">close</v-icon>
            </v-btn>
          </div>
        </div>
      </li>
    </ul>
  </article>
</template>

<script>
import PlChatAvatar from './PlChatAvatar'
import { getNameWithLastFourSymbolPhoneNumber } from '@/helpers/nameWithLastFourSymbolPhoneNumber'

export default {
  name: 'PlChatMembersList',
  components: {
    PlChatAvatar,
  },
  data() {
    return {
      filterValue: '',
    }
  },
  props: {
    members: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      if (this.filterValue === '') {
        return this.members
      } else {
        return this.members.filter(member => this.checkFilter(member.name)).slice()
      }
    },
  },
  methods: {
    checkFilter(str) {
      const lowerStr = str.toLowerCase()
      const lowerFilterValue = this.filterValue.toLowerCase()

      return lowerStr.includes(lowerFilterValue)
    },
    itSelf(id) {
      return id === this.$store.state.plChat.profile.id
    },
    getNumberPhoneMember(member) {
      return getNameWithLastFourSymbolPhoneNumber(member)
    },
  },
}
</script>

<style scoped lang="scss">
.pl-chat-user-list {
  list-style-type: none;
  padding: 0 1rem 1rem;
  overflow-y: scroll;
  max-height: calc(85vh - 13.5rem - 96px);

  &__users-list-subtitle {
    padding: 1rem 1rem 0;
    text-align: center;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.5rem;
    margin-bottom: 0.2rem;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  &__item--not-change {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &__item-body {
    display: flex;
    justify-content: space-between;
    flex: 1 1 auto;
  }

  &__name {
    margin: 1rem;
    max-height: 3rem;
    overflow: hidden;
  }

  &__button-action {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__filter {
    padding-left: 1rem;
    padding-right: 1.6rem;
  }

  &__search {
    display: flex;
    align-items: flex-end;
    padding: 0 1rem;
  }
}
</style>
